export const LOAD_FLOW = 'LOAD_FLOW';
export const SAVE_FLOW = 'SAVE_FLOW';
export const LOAD_FLOWS = 'LOAD_FLOWS';
export const UPDATE_STATUS = 'UPDATE_STATUS';
